//
// itkModulesPath is the path that contains the directories
//
// - WebWorkers/
// - ImageIOs/
// - MeshIOs/
//
var itkConfig = {
  itkModulesPath: 'itk'
};

export default itkConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/itk/itkConfig.js
// module id = 14
// module chunks = 0